// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FpOLf","label":"styles_label__Gen-l"};